export default {
  alias      : 'tramite_doc_generado',
  route      : '/tramite/docGenerado',
  hash       : false,
  store      : false,
  name       : 'dgen_html',
  key        : 'id',
  selectable : false,
  default    : {
    id                 : null,
    dgen_html          : null,
    dgen_datos         : {},
    dgen_derivaciones  : [],
    dgen_referencias   : [],
    dgen_idadmin       : null,
    dgen_iddependencia : null,
    created_at         : null,
    updated_at         : null,
  }
}
  